// Module
var code = "<ngx-login (on-sign-up)=\"$ctrl.toSignUp()\" (on-forgot-password)=\"$ctrl.forgotPassword()\" (on-login)=\"$ctrl.submit($event)\" (on-login-with-sso)=\"$ctrl.loginWithSso($event)\" [disabled-button]=\"$ctrl.loading\" [error-message]=\"$ctrl.formError\"></ngx-login>";
// Exports
module.exports = code;